const LoaderEquipment = () => {
    return (
        <div className="text-center">
            <div className="spinner-grow spinner-grow-sm" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    )
}
export default LoaderEquipment